import {$grouped} from './groupedKanji';

export const $sorted = $grouped.map((grouped) => {
  const keys = Object.keys(grouped);
  keys.sort((a, b) => grouped[b].length - grouped[a].length);
  return keys
})
